import { forwardRef, HTMLProps } from "react"
import { cn } from "@/lib/utils"

// need to omit ref since we are using forward ref
// but i forgot exactly why
export type RadioProps = Omit<HTMLProps<HTMLInputElement>, "ref">

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
	({ className, ...rest }, ref) => {
		return (
			<input
				type="radio"
				ref={ref}
				className={cn(
					"h-4 w-4 border-gray-300 text-primary-500 focus:ring-primary-500",
					className,
				)}
				{...rest}
			/>
		)
	},
)
Radio.displayName = "Radio"
